import React, { lazy } from "react";

import { FeScheme, PAGES } from "src/types/navigation";

export type Roles = "guest" | "authenticated";

export const pagesRedirect: Record<Roles, FeScheme> = {
  guest: [{ scheme: PAGES.AUTH }],
  authenticated: [{ scheme: PAGES.SEND }],
};

export type PageRoute = {
  access: "all" | Roles[];
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<any>;
  icon?: React.FC;
};
export type ModalRoute = PageRoute;

export const pages: Record<PAGES, PageRoute> = {
  [PAGES.ROOT]: {
    access: ["authenticated"],
    title: "Root",
    component: lazy(() => import("src/components/routes/pages/Root")),
  },
  [PAGES.SETTINGS]: {
    access: ["authenticated"],
    title: "Settings",
    component: lazy(() => import("src/components/routes/pages/Settings")),
  },
  [PAGES.AUTH]: {
    access: ["guest"],
    title: "Login",
    component: lazy(() => import("src/components/routes/pages/AuthLogin")),
  },
  [PAGES.CONFIRM_LOGIN]: {
    access: ["guest"],
    title: "Confirmation",
    component: lazy(
      () => import("src/components/routes/pages/AuthConfirmation")
    ),
  },
  [PAGES.SEND]: {
    access: ["authenticated"],
    title: "Send",
    component: lazy(() => import("src/components/routes/pages/Send")),
  },
  [PAGES.RECEIPT]: {
    access: ["authenticated"],
    title: "Receipt",
    component: lazy(() => import("src/components/routes/pages/Receipt")),
  },
  [PAGES.DOCUMENTS]: {
    access: ["authenticated"],
    title: "Documents",
    component: lazy(() => import("src/components/routes/pages/Documents")),
  },
  [PAGES.STATISTICS]: {
    access: ["authenticated"],
    title: "Statistics",
    component: lazy(() => import("src/components/routes/pages/Statistics")),
  },
  [PAGES.DASHBOARD]: {
    access: ["authenticated"],
    title: "Dashboard",
    component: lazy(() => import("src/components/routes/pages/Dashboard")),
  },
  [PAGES.TRACKING]: {
    access: ["authenticated"],
    title: "Tracking",
    component: lazy(() => import("src/components/routes/pages/Tracking")),
  },
  [PAGES.CREATE_DISPATCH]: {
    access: ["authenticated"],
    title: "Create dispatch",
    component: lazy(() => import("src/components/routes/pages/CreateDispatch")),
  },
  // This item must be the last in the list
  [PAGES.ERROR_404]: {
    access: "all",
    title: "Not found",
    component: lazy(() => import("src/components/routes/pages/Error404")),
  },
};
